export const WHATSAPP_NUMBER = "221778034960"; // format international, sans le "+"
export const CONTACT_PHONE_DISPLAY = "+221 77 803 49 60";
export const CONTACT_PHONE_HREF = "tel:+221778034960";
export const CONTACT_EMAIL = "contact@layetech.sn";